var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:({width: _vm.width, height: _vm.height})},[_c('div',{staticClass:"loading-layer",style:({width: _vm.width, height: _vm.height})}),_c('img',{attrs:{"src":require("../../assets/images/common/data-loading.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }